export default __webpack_public_path__ + "static/logo-bda0694070fca7c61b660feb32493d3c.svg";